import React from "react";
import { Icon, Header, Menu } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

const Tile = ({ title, icon, iconSize, t, onClick, id, component }) => (
	<Menu.Item className="tile" onClick={onClick} style={{ cursor: "pointer" }}>
		{icon && <Icon name={icon} size={iconSize} className="tileIcon" />}
		<Header id={id} className="tileHeader">
			{t(title)}
		</Header>
		{component && <div className="tileComponent">{component}</div>}
	</Menu.Item>
);

Tile.propTypes = {
	title: PropTypes.string,
	icon: PropTypes.string,
	iconSize: PropTypes.string,
	t: PropTypes.func,
	onClick: PropTypes.func,
	id: PropTypes.string,
	component: PropTypes.element
};

Tile.defaultProps = {
	title: "",
	icon: "",
	iconSize: "huge",
	t: () => {},
	onClick: () => {},
	id: "",
	component: <></>
};

export default withTranslation()(Tile);
